// extracted by mini-css-extract-plugin
export default {"title":"LodgingDetails_title__FVxsi","segment":"LodgingDetails_segment__RA+XR","edit":"LodgingDetails_edit__GM67g"};